import React from "react";
import * as S from "./InputText.styled";
import { ReactComponent as IconError } from "../../../../../assets/images/habitacional/rounded-warning.svg";

const InputText = ({
  title,
  value,
  onChange,
  placeholder,
  defaultValue,
  icon,
  hasError,
  errorMessage,
  type,
  maxLength,
  mask,
  maskPlaceholder = "",
  margin,
  CalendarPicker,
  isRequired,
  ...props
}) => {
  return (
    <S.InputContainer>
      <S.Title htmlFor={title} margin={margin}>
        {title} {isRequired && (<S.RequiredIcon>*</S.RequiredIcon>)}
      </S.Title>
      <S.MaskedStyledTextField
        label={title}
        onChange={onChange}
        placeholder={placeholder}
        defaultValue={defaultValue}
        icon={icon}
        value={value}
        errormessage={hasError ? errorMessage : ""}
        type={type}
        id={title}
        mask={value ? mask : null}
        hasError={hasError}
        maskPlaceholder={maskPlaceholder}
        CalendarPicker={CalendarPicker}
        {...props}
      />
      {hasError && errorMessage && (
        <S.ErrorMessage>
          <IconError />
          {errorMessage}
        </S.ErrorMessage>
      )}
    </S.InputContainer>
  );
};

export default InputText;
